<template>
  <div class="lc-page">
    <div class="container">
      <div class="title_holder">
        <h3>{{$t("nav.references")}}</h3>
        <div class="breadcrumbs">
          <ul>
            <li class="item-home">
              <router-link class="bread-link bread-home" to="/" title="Home"
                >{{$t("nav.main")}}</router-link
              >
            </li>
            <li class="separator separator-home">
              <span></span>
            </li>
            <li class="item-current">
              <span class="bread-current">{{$t("nav.references")}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="lc-list">
        <div class="row">
          <VueGallery
            :images="imageTarget"
            :index="index"
            @close="index = null"
          ></VueGallery>
          <div
            class="col-md-3 as-gallery"
            v-for="(img, index) in letters"
            :key="img.name"
            @click="ChangeImage(index, img.img)"
          >
            <div class="img_holder">
              <span class="name">{{ img.name }}</span>
              <img
                :src="require('../assets/images/thanksLetters/' + img.img)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";
export default {
  data() {
    return {
      index: null,
      imageTarget: [],
      letters: [
        {
          name: "BUNGE",
          img: "bunge.jpg"
        },
        {
          name: "DANIELI",
          img: "daniela.jpg"
        },
        {
          name: "ГУАЛАПАК УКРАИНА",
          img: "gyalapak.jpg"
        },
        {
          name: "МЕГАЛАЙН ТРЦ ЛАВИНА",
          img: "megaline.jpg"
        },
        {
          name: "АЛКОМ ОЛСИДЗ",
          img: "olsidz.jpg"
        },
        {
          name: "УКРБУД",
          img: "ukrbyd.jpg"
        },
        {
          name: "ОРЕКСИМ",
          img: "orexim.jpg"
        }
      ]
    };
  },
  methods: {
    ChangeImage: function(index, item) {
      this.index = index;
      for (var i = 0; i < this.letters.length; i++) {
        this.imageTarget.push(
          require("../assets/images/thanksLetters/" + this.letters[i].img)
        );
      }
    }
  },
  components: {
    VueGallery
  }
};
</script>

<style>
.lc-page .title_holder {
  position: relative;
  padding: 95px 0 35px;
  width: 100%;
  float: left;
  clear: both;
  margin-bottom: 30px;
}
.lc-page .title_holder .breadcrumbs {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  padding-top: 13px;
  padding-bottom: 2px;
}
.lc-page .title_holder .breadcrumbs ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.lc-page .title_holder .breadcrumbs li {
  float: left;
  margin-bottom: 5px;
}
.lc-page .title_holder .breadcrumbs li a {
  font-size: 14px;
  color: #666;
  text-decoration: none;
  letter-spacing: 0;
  line-height: 1.5;
  font-weight: 600;
}
.lc-page .title_holder .breadcrumbs .separator span {
  width: 33px;
  height: 24px;
  display: block;
  position: relative;
}
.lc-page .title_holder .breadcrumbs .separator span:after,
.lc-page .title_holder .breadcrumbs .separator span:before {
  width: 9px;
  height: 2px;
  display: block;
  position: absolute;
  background-color: #ddd;
  left: 13px;
  content: "";
}
.lc-page .title_holder .breadcrumbs .separator span:before {
  top: 14px;
  transform: rotate(135deg);
}
.lc-page .title_holder .breadcrumbs .separator span:after {
  top: 8px;
  transform: rotate(45deg);
}
.lc-page .img_holder {
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border: 6px solid rgba(255, 255, 255, 0.75);
  margin-right: 5px;
  overflow: hidden;
  margin-bottom: 30px;
}
.lc-page .img_holder .name {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(127, 127, 127, 0.8);
  padding: 5px 10px;
  z-index: 1;
}
.lc-page .img_holder img {
  opacity: 0.5;
  height: 300px;
  width: 100%;
  object-fit: cover;
}
</style>
